import axiosClient from "../axios/axiosClient";

export function getAffiliations() {
  return axiosClient.get("/affiliations");
}

export function getAffiliation(affiliationId) {
  return axiosClient.get(`/affiliations/${affiliationId}`);
}

export function createAffiliation(data) {
  return axiosClient.post("/affiliations", data);
}

export const updateAffiliation = (affiliationId, data) => {
  return axiosClient.put(`/affiliations/${affiliationId}`, data);
};

export function deleteAffiliation(affiliationId) {
  return axiosClient.delete(`/affiliations/${affiliationId}`);
}
